import React from 'react';
import styled from 'styled-components';
import { Inputs } from '../../types/Enums';
import { FlowsQuestion } from '../../types/FlowsTypes';
import InputSelector from '../input/InputSelector';

const ComponentOverview: React.FC<React.PropsWithChildren<unknown>> = () => {
  const dummyQuestions: FlowsQuestion[] = Object.values(Inputs).map(
    (val, index) => ({
      id: `dummy_question_${index}`,
      rules: {
        mandatory: true,
        input_type: val,
        data_type: 'STRING',
        enum: [
          {
            OWNER: {
              nl: 'Eigenaar en bewoner',
              en: 'Owner and resident',
              fr: 'Propri\u00e9taire et occupant',
            },
          },
          {
            TENANT: {
              nl: 'Huurder',
              en: 'Tenant',
              fr: 'Locataire',
            },
          },
          {
            LANDLORD: {
              nl: 'Eigenaar, niet bewoner',
              en: 'Owner, non resident',
              fr: 'Propri\u00e9taire, non occupant',
            },
          },
          {
            CO_TENANT: {
              nl: 'Medehuurder',
              en: 'Co-tenant',
              fr: 'Co-locataire',
            },
          },
        ],
        is_disabled: false,
      },
      tag: 'HOME',
      field: 'holder_state',
      error_messages: {
        mandatory: {
          nl: 'Hoedanigheid is verplicht.',
          en: 'Policy holder category is required.',
          fr: 'Responsabilit\u00e9 est obligatoire.',
        },
      },
    }),
  );

  return (
    <OuterWrapper>
      <Wrapper>
        {dummyQuestions.map((question) => (
          <QuestionWrapper key={question.id}>
            <QuestionTitle>{question.rules.input_type}:</QuestionTitle>
            <InputSelector question={question} />
          </QuestionWrapper>
        ))}
      </Wrapper>
    </OuterWrapper>
  );
};

const QuestionTitle = styled.h1`
  font-size: 2.4rem;
  line-height: 125%;
  margin-bottom: 1.6rem;
`;

const QuestionWrapper = styled.div`
  margin: 5.6rem 0;

  &:first-child {
    margin-top: 2.4rem;
  }

  &:last-child {
    margin-bottom: 2.4rem;
  }
`;

const Wrapper = styled.div`
  padding: 3.2rem;
  max-width: 104.5rem;
  margin: 0 auto;
`;

const OuterWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: white;
  overflow-y: auto;
`;

export default ComponentOverview;
